module.exports = __webpack_public_path__ + "static/media/image_11.dee7c095.png";